module.exports = __webpack_public_path__ + "img/table-icon.e97397cf.svg";